import TopMenuDesktopSubMenu from './sub-menu';
import { IITopMenuDesktopItem } from '../../../interfaces';

interface ITopMenuDesktopSubMenuWrapperProps {
    item: IITopMenuDesktopItem;
}

const TopMenuDesktopSubMenuWrapper = ({ item }: ITopMenuDesktopSubMenuWrapperProps) => {

    const sectionsNumber = item.subMenu?.length || 0;

    return (
        <div
            className="waves-top-menu-drop invisible grid gap-4 grid-cols-3 absolute top-full left-0 bg-white text-gray-500 shadow-md rounded px-4 py-2 text-tiny ml-3 border border-gray-100"
            style={{
                gridTemplateColumns: `repeat(${ sectionsNumber }, minmax(170px, 1fr))`,
                msGridColumns: `(minmax(170px, 1fr))[${ sectionsNumber }]`,
            }}>

            {
                item.subMenu?.map((subMenuItem, j) => {
                    return (
                        <TopMenuDesktopSubMenu
                            key={ `sub-menu-item-${ j }` }
                            index={ j }
                            item={ item }
                            subMenuItem={ subMenuItem }
                        />
                    )
                })
            }
        </div>
    )
};

export default TopMenuDesktopSubMenuWrapper;